import {useRefinementList} from "react-instantsearch-hooks-web";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import {find, forEach, kebabCase, split} from "lodash";
import Checkbox from "../Checkbox";
import Title from "../../Elements/Title";

const RefinementList = props => {
    const { values, attribute } = props
    const {
        items,
        refine,
        canRefine
    } = useRefinementList(props);

    const [filteredItems, setFilteredItems] = useState([])

    const isChecked = useCallback((item) => {
        return (values !== undefined && values !== '' && values !== 0 && item.count > 0) ? values.includes(item.label) : false
    }, [values])

    useMemo(() => {
        if (items.length <= filteredItems.length) {
            forEach(filteredItems, filteredItem => {
                const data = find(items, item => item.label === filteredItem.label)
                filteredItem.count = data !== undefined ? data.count : 0
            })
        }
    }, [items, filteredItems])

    useEffect(() => {
        if (items.length > filteredItems.length) {
            setFilteredItems(items)
        }
    }, [items])

    return (
        filteredItems.length > 0 ?
            <>
                {props.title ? <Title text={props.title} /> : null}
                <div className={'grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-2'}>
                    {filteredItems.map(item => (
                        <Checkbox item={item}
                                  attribute={split(attribute, '.')[0] + '[]'}
                                  canRefine={canRefine}
                                  refine={refine}
                                  checked={isChecked(item)}
                                  key={'checkbox-' + kebabCase(item.label)}
                        />
                    ))}
                </div>
            </> :
            null
    );
}

export default RefinementList